import Modal from './modal.js';

class HolidayForm {
    constructor() {
        this.modal          = new Modal('holidayModal');
        this.modalElement   = document.getElementById('holidayModal');
        this.form           = document.getElementById('holidayForm');
        this.userNameInput  = document.getElementById('holidayUserName');
        this.userPhoneInput = document.getElementById('holidayUserPhone');
        this.ageInput       = document.getElementById('holidayPlayersAge');
        this.submitBtn      = document.getElementById('holidaySubmit');
        this.closeBtn       = document.getElementById('holidayModalClose');
        this.errorsContainer    = document.getElementById('holidayErrors');
        this.disclaimerCheckbox = document.getElementById('holidayDisclaimer');
        this.successEl      = document.getElementById('holidaySuccess');
        this.footerEl       = document.getElementById('holidayFooter');

        // Календар
        this.calDaysEl      = document.getElementById('holidayCalDays');
        this.calMonthEl     = document.getElementById('holidayCalMonth');
        this.calPrevBtn     = document.getElementById('holidayCalPrev');
        this.calNextBtn     = document.getElementById('holidayCalNext');
        this.selectedDatesEl  = document.getElementById('holidaySelectedDates');
        this.selectedTagsEl   = document.getElementById('holidaySelectedTags');

        this.errors       = {};
        this.selectedDates = []; // масив рядків 'YYYY-MM-DD'

        // Поточний місяць у календарі
        const now = new Date();
        this.calYear  = now.getFullYear();
        this.calMonth = now.getMonth(); // 0-based

        this.init();
    }

    init() {
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.modal.close());
        }

        if (this.userNameInput) {
            this.userNameInput.addEventListener('input', () => this.clearFieldError(this.userNameInput));
        }
        if (this.userPhoneInput) {
            this.userPhoneInput.addEventListener('input', (e) => {
                this.formatPhoneInput(e.target);
                this.clearFieldError(this.userPhoneInput);
            });
        }
        if (this.ageInput) {
            this.ageInput.addEventListener('input', () => this.clearFieldError(this.ageInput));
        }

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                if (this.submitBtn && this.submitBtn.disabled) return;
                this.handleSubmit();
            });
        }

        // Навігація по календарю
        if (this.calPrevBtn) {
            this.calPrevBtn.addEventListener('click', () => {
                this.calMonth--;
                if (this.calMonth < 0) { this.calMonth = 11; this.calYear--; }
                this.renderCalendar();
            });
        }
        if (this.calNextBtn) {
            this.calNextBtn.addEventListener('click', () => {
                this.calMonth++;
                if (this.calMonth > 11) { this.calMonth = 0; this.calYear++; }
                this.renderCalendar();
            });
        }

        this.renderCalendar();

        // Тригери відкриття
        document.querySelectorAll('[data-modal="holidayModal"]').forEach((btn) => {
            btn.addEventListener('click', () => this.open());
        });
        const triggerBtn = document.getElementById('holidayCardBtn');
        if (triggerBtn) {
            triggerBtn.addEventListener('click', () => this.open());
        }
    }

    open() {
        this.resetForm();
        this.modal.open();
    }

    // ── Календар ──────────────────────────────────────────────────────────────

    renderCalendar() {
        if (!this.calDaysEl || !this.calMonthEl) return;

        const monthNames = [
            'Січень','Лютий','Березень','Квітень','Травень','Червень',
            'Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'
        ];
        this.calMonthEl.textContent = `${monthNames[this.calMonth]} ${this.calYear}`;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Перший день місяця (0=Нд..6=Сб → конвертуємо в Пн=0)
        const firstDay = new Date(this.calYear, this.calMonth, 1);
        let startDow = firstDay.getDay(); // 0=Нд
        startDow = (startDow === 0) ? 6 : startDow - 1; // Пн=0

        const daysInMonth = new Date(this.calYear, this.calMonth + 1, 0).getDate();

        this.calDaysEl.innerHTML = '';

        // Порожні клітинки на початку
        for (let i = 0; i < startDow; i++) {
            const empty = document.createElement('div');
            empty.className = 'holiday-calendar__day holiday-calendar__day--empty';
            this.calDaysEl.appendChild(empty);
        }

        for (let d = 1; d <= daysInMonth; d++) {
            const date = new Date(this.calYear, this.calMonth, d);
            date.setHours(0, 0, 0, 0);
            const key = this.dateToKey(date);

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'holiday-calendar__day';
            btn.textContent = d;

            if (date < today) {
                btn.classList.add('holiday-calendar__day--disabled');
            } else {
                if (this.selectedDates.includes(key)) {
                    btn.classList.add('holiday-calendar__day--selected');
                }
                btn.addEventListener('click', () => this.toggleDate(key, btn));
            }

            this.calDaysEl.appendChild(btn);
        }
    }

    toggleDate(key, btn) {
        const idx = this.selectedDates.indexOf(key);
        if (idx === -1) {
            this.selectedDates.push(key);
            btn.classList.add('holiday-calendar__day--selected');
        } else {
            this.selectedDates.splice(idx, 1);
            btn.classList.remove('holiday-calendar__day--selected');
        }
        this.renderSelectedTags();
    }

    renderSelectedTags() {
        if (!this.selectedTagsEl || !this.selectedDatesEl) return;

        this.selectedTagsEl.innerHTML = '';

        if (this.selectedDates.length === 0) {
            this.selectedDatesEl.style.display = 'none';
            return;
        }

        this.selectedDatesEl.style.display = 'flex';

        // Сортуємо дати
        const sorted = [...this.selectedDates].sort();

        sorted.forEach(key => {
            const [y, m, d] = key.split('-');
            const label = `${d}.${m}.${y}`;

            const tag = document.createElement('span');
            tag.className = 'holiday-calendar__tag';
            tag.innerHTML = `
                ${label}
                <button type="button" class="holiday-calendar__tag-remove" data-key="${key}" aria-label="Видалити">×</button>
            `;
            tag.querySelector('.holiday-calendar__tag-remove').addEventListener('click', () => {
                this.removeDate(key);
            });
            this.selectedTagsEl.appendChild(tag);
        });
    }

    removeDate(key) {
        this.selectedDates = this.selectedDates.filter(d => d !== key);
        this.renderCalendar();
        this.renderSelectedTags();
    }

    dateToKey(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }

    formatDatesForMessage() {
        return [...this.selectedDates]
            .sort()
            .map(key => {
                const [y, m, d] = key.split('-');
                return `${d}.${m}.${y}`;
            })
            .join(', ');
    }

    // ── Форматування телефону ─────────────────────────────────────────────────

    formatPhoneInput(input) {
        let value = input.value.replace(/\D/g, '');
        if (value.startsWith('380')) {
            value = '380' + value.substring(3);
        } else if (value.length > 0) {
            value = '380' + value;
        }
        if (value.length > 0) {
            let formatted = '+380 ';
            const rest = value.substring(3);
            if (rest.length === 0)       formatted = '+380 ';
            else if (rest.length <= 2)   formatted += rest;
            else if (rest.length <= 5)   formatted += `${rest.substring(0,2)}-${rest.substring(2)}`;
            else if (rest.length <= 7)   formatted += `${rest.substring(0,2)}-${rest.substring(2,5)}-${rest.substring(5)}`;
            else                         formatted += `${rest.substring(0,2)}-${rest.substring(2,5)}-${rest.substring(5,7)}-${rest.substring(7,9)}`;
            input.value = formatted;
        } else {
            input.value = '';
        }
    }

    // ── Валідація ─────────────────────────────────────────────────────────────

    validateName() {
        const name = this.userNameInput ? this.userNameInput.value.trim() : '';
        if (!name || name.length < 2) {
            this.showError(this.userNameInput, 'Будь ласка, введіть ваше ім\'я');
            return false;
        }
        this.hideError(this.userNameInput);
        return true;
    }

    validatePhone() {
        const phone = this.userPhoneInput ? this.userPhoneInput.value.trim() : '';
        if (!phone || phone.replace(/\D/g, '').length < 12) {
            this.showError(this.userPhoneInput, 'Будь ласка, введіть правильний номер телефону');
            return false;
        }
        this.hideError(this.userPhoneInput);
        return true;
    }

    validateAge() {
        const age = this.ageInput ? this.ageInput.value.trim() : '';
        if (!age) {
            this.showError(this.ageInput, 'Будь ласка, вкажіть вік гравців');
            return false;
        }
        this.hideError(this.ageInput);
        return true;
    }

    validateForm() {
        let isValid = true;
        this.clearAllErrors();

        if (!this.validateName())  isValid = false;
        if (!this.validatePhone()) isValid = false;
        if (!this.validateAge())   isValid = false;

        if (!this.disclaimerCheckbox || !this.disclaimerCheckbox.checked) {
            isValid = false;
            this.showFormError('Будь ласка, підтвердіть згоду з угодою користувача');
        }

        return isValid;
    }

    // ── Відправка ─────────────────────────────────────────────────────────────

    async handleSubmit() {
        if (!this.validateForm()) return;

        this.setLoading(true);

        try {
            const response = await fetch('/wp-json/pozamezh/v1/lead', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name:         this.userNameInput.value.trim(),
                    phone:        this.userPhoneInput.value.trim(),
                    players_age:  this.ageInput.value.trim(),
                    dates:        this.selectedDates.length > 0 ? this.formatDatesForMessage() : 'Не вказано',
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                this.showSuccess();
            } else {
                this.showFormError(data.message || 'Сталася помилка. Спробуйте ще раз.');
                this.setLoading(false);
            }
        } catch (error) {
            console.error('HolidayForm error:', error);
            this.showFormError('Помилка відправки форми. Спробуйте ще раз.');
            this.setLoading(false);
        }
    }

    setLoading(state) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = state;
        const spinner = this.submitBtn.querySelector('.btn__spinner');
        const text    = this.submitBtn.querySelector('.btn__text');
        if (spinner && text) {
            text.style.visibility = state ? 'hidden' : 'visible';
            spinner.style.display = state ? 'flex' : 'none';
        }
    }

    showSuccess() {
        if (this.form) {
            const body = this.form.querySelector('.booking-modal__body');
            if (body) body.style.display = 'none';
        }
        if (this.footerEl)    this.footerEl.style.display = 'none';
        if (this.errorsContainer) this.errorsContainer.innerHTML = '';
        if (this.successEl)   this.successEl.style.display = 'flex';
    }

    // ── Помилки ───────────────────────────────────────────────────────────────

    showError(input, message) {
        if (!input) return;
        this.errors[input.id] = message;
        const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
        if (wrapper) {
            wrapper.classList.add('booking-modal__input-wrapper--error');
            if (!wrapper.querySelector('.booking-modal__error-icon')) {
                const icon = document.createElement('div');
                icon.className = 'booking-modal__error-icon';
                icon.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="8" stroke="#ff6b6b" stroke-width="1.5" fill="none"/>
                    <path d="M10 6V10" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M10 14H10.01" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                </svg>`;
                wrapper.appendChild(icon);
            }
        }
        this.renderErrors();
    }

    hideError(input) {
        if (!input) return;
        delete this.errors[input.id];
        const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
        if (wrapper) {
            wrapper.classList.remove('booking-modal__input-wrapper--error');
            const icon = wrapper.querySelector('.booking-modal__error-icon');
            if (icon) icon.remove();
        }
        this.renderErrors();
    }

    clearFieldError(input) {
        if (!input || !this.errors[input.id]) return;
        delete this.errors[input.id];
        const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
        if (wrapper) {
            wrapper.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
            const icon = wrapper.querySelector('.booking-modal__error-icon');
            if (icon) icon.remove();
        }
        this.renderErrors();
        this.clearFormError();
    }

    showFormError(message) {
        if (!this.errorsContainer) return;
        const el = document.createElement('div');
        el.className = 'booking-modal__error booking-modal__error--form';
        el.textContent = message;
        this.errorsContainer.appendChild(el);
    }

    clearFormError() {
        if (!this.errorsContainer) return;
        this.errorsContainer.querySelectorAll('.booking-modal__error--form').forEach(e => e.remove());
    }

    renderErrors() {
        if (!this.errorsContainer) return;
        const formErrors = this.errorsContainer.querySelectorAll('.booking-modal__error--form');
        if (formErrors.length === 0 && Object.keys(this.errors).length === 0) {
            this.errorsContainer.innerHTML = '';
            return;
        }
        let html = '';
        formErrors.forEach(e => { html += e.outerHTML; });
        Object.values(this.errors).forEach(msg => {
            const el = document.createElement('div');
            el.className = 'booking-modal__error';
            el.textContent = msg;
            html += el.outerHTML;
        });
        this.errorsContainer.innerHTML = html;
    }

    clearAllErrors() {
        this.errors = {};
        if (this.errorsContainer) this.errorsContainer.innerHTML = '';
        if (this.modalElement) {
            this.modalElement.querySelectorAll('.booking-modal__input-wrapper--error, .booking-modal__textarea-wrapper--error').forEach(w => {
                w.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
                const icon = w.querySelector('.booking-modal__error-icon');
                if (icon) icon.remove();
            });
        }
    }

    // ── Скидання форми ────────────────────────────────────────────────────────

    resetForm() {
        this.clearAllErrors();
        if (this.form) {
            const body = this.form.querySelector('.booking-modal__body');
            if (body) body.style.display = '';
        }
        if (this.footerEl)    this.footerEl.style.display = '';
        if (this.successEl)   this.successEl.style.display = 'none';
        if (this.userNameInput)  this.userNameInput.value = '';
        if (this.userPhoneInput) this.userPhoneInput.value = '';
        if (this.ageInput)       this.ageInput.value = '';
        if (this.disclaimerCheckbox) this.disclaimerCheckbox.checked = false;

        // Скидаємо календар
        this.selectedDates = [];
        const now = new Date();
        this.calYear  = now.getFullYear();
        this.calMonth = now.getMonth();
        this.renderCalendar();
        this.renderSelectedTags();

        this.setLoading(false);
    }
}

export default HolidayForm;